import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { LoginUser, forgetPassword, setNewPassword, verifyOtp } from './actions';
import { toast } from 'react-toastify';

// Type definition for the initial state
interface AuthState {
  auth: any;
  isLoggedIn: boolean;
  referral_code: string;
  data: any;
  forgetData: any;
  role: string | null;
  Loading: boolean;
  verfyOtp: any;
  error: any;
}

/* // Improved null safety handling
const user = (() => {
  // Checking if token exists in localStorage and setting initial state accordingly
  // const token = localStorage.getItem('token');
  const token = localStorage.getItem('jwt_token') ? localStorage.getItem('jwt_token') : null;
  return token ? JSON.parse(token) : null;
})(); */

const user = (() => {
  const token = localStorage.getItem('jwt_token');
  try {
    return token ? JSON.parse(token) : null;
  } catch {
    return null;
  }
})();

const initialState: AuthState = {
  auth: null,
  isLoggedIn: user ? true : false,
  referral_code: localStorage.getItem('referral_code') || "",
  data: null,
  forgetData: null,
  role: null,
  Loading: false,
  verfyOtp: null,
  error: null,
};

// Create slice with builder callback notation for extraReducers
export const AuthReducer = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    LogOut: (state) => {
      localStorage.removeItem('jwt_token');
      localStorage.removeItem('referral_code');
      state.data = null;
      state.isLoggedIn = false;
      toast.success('Logged out successfully');
    },
    setReferralCode: (state, action) => {
      state.referral_code = action.payload;
      localStorage.setItem('referral_code', action.payload);
      state.isLoggedIn = true;
    },
    setCurrentUser: (state, action: PayloadAction<any>) => {
      state.data = action.payload;
      state.role = action.payload.role;
      state.isLoggedIn = true;
    },
  },
  extraReducers: (builder) => {
    builder
      // Handle pending state for login
      .addCase(LoginUser.pending, (state) => {
        state.Loading = true;
      })
      // Handle fulfilled state for login
      .addCase(LoginUser.fulfilled, (state, { payload }) => {
        state.referral_code = payload.data?.referral_code as string;
        localStorage.setItem('referral_code', payload.data?.referral_code || ""); // Store referral code
        state.isLoggedIn = true;
        state.Loading = false;

        state.data = payload;
        state.role = payload.data?.role as string;
        // state.role = payload.data.role;
      })
      // Handle rejected state for login
      .addCase(LoginUser.rejected, (state, action) => {
        state.error = action.payload;
        state.Loading = false;
      })
      // Handle pending state for forget password
      .addCase(forgetPassword.pending, (state) => {
        state.Loading = true;
      })
      // Handle fulfilled state for forget password
      .addCase(forgetPassword.fulfilled, (state, action) => {
        state.forgetData = action.payload;
        state.Loading = false;
      })
      // Handle rejected state for forget password
      .addCase(forgetPassword.rejected, (state, action) => {
        state.error = action.payload;
        state.Loading = false;
      })
      // Handle pending state for verify OTP
      .addCase(verifyOtp.pending, (state) => {
        state.Loading = true;
      })
      // Handle fulfilled state for verify OTP
      .addCase(verifyOtp.fulfilled, (state, action) => {
        state.Loading = false;
        state.verfyOtp = action.payload;
      })
      // Handle rejected state for verify OTP
      .addCase(verifyOtp.rejected, (state, action) => {
        state.Loading = false;
        state.error = action.payload;
      })
      // Handle fulfilled state for setting new password
      .addCase(setNewPassword.fulfilled, (state, action) => {
        console.log(action.payload);
      });
  },
});

export const { LogOut, setReferralCode, setCurrentUser } = AuthReducer.actions;
export default AuthReducer.reducer;




/* import { createSlice } from '@reduxjs/toolkit'
import { LoginUser, forgetPassword, setNewPassword, verifyOtp } from './actions';

//if token is available in local storage we rediret into dashboard page
const user = localStorage.getItem("token") ? JSON.parse(localStorage.getItem("token")) : null

export const AuthReducer = createSlice({
    name: 'auth',
    initialState: {
        auth: null,
        isLoggedIn: user ? true : false,
        data: null,
        forgetData: null,
        role: null,
        Loading: false,
        verfyOtp: null,
        error: null
    },
    reducers: {
        LogOut: (state, action) => {
            localStorage.removeItem('token');
            state.data = null
            state.isLoggedIn = false
        },
        setCurrentUser: (state, action) => {
            state.data = action.payload
            state.role = action.payload.role
            state.isLoggedIn = true
        }
    },
    extraReducers: {
        [LoginUser.pending]: (state, action) => {
            state.Loading = true
        },
        [LoginUser.fulfilled]: (state, { payload }) => {
            state.Loading = false;
            if (payload.status === "failure") {
                state.error = payload;
            }
            state.data = payload;
            state.role = payload.data.role;
        },
        [LoginUser.rejected]: (state, action) => {
            state.error = action.payload;
            state.Loading = false;
        },
        [forgetPassword.pending]: (state, action) => {
            state.Loading = true;
        },
        [forgetPassword.fulfilled]: (state, action) => {
            state.forgetData = action.payload;
            state.Loading = false;
        },
        [forgetPassword.rejected]: (state, action) => {
            state.error = action.payload;
            state.Loading = false;
        },
        [verifyOtp.pending]: (state, action) => {
            state.Loading = true;
        },
        [verifyOtp.fulfilled]: (state, action) => {
            state.Loading = false;
            state.verfyOtp = action.payload;
        },
        [verifyOtp.rejected]: (state, action) => {
            state.Loading = false;
            state.error = action.payload;
        },
        [setNewPassword.fulfilled]: (state, action) => {
            console.log(action.payload);
        },
    }
})

export const { LogOut, setCurrentUser } = AuthReducer.actions
export default AuthReducer.reducer */